// Karha — fix mobile
(function() {
  // Fix scrollbar .grid--flush-bottom (grid.css overflow:auto) — tous ecrans
  function fixGridFlushBottom() {
    document.querySelectorAll('.grid--flush-bottom').forEach(function(el) {
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', fixGridFlushBottom);
  window.addEventListener('load', fixGridFlushBottom);
  setTimeout(fixGridFlushBottom, 500);
  setTimeout(fixGridFlushBottom, 1500);
})();
